import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ClientEventApi } from 'wklr-backend-sdk/apis';
import { getSerializable } from '@/utility';
/** Errorオブジェクトを文字列に変換し、maxLength文字以下に切り詰める */
var stringifyErrorObject = function stringifyErrorObject(error) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10000;
  return JSON.stringify(getSerializable(error)).substr(0, maxLength);
};
export default (function (_ref, inject) {
  var app = _ref.app;
  var api = new ClientEventApi(undefined, '', app.$axios);
  var sendTelemetry = function sendTelemetry(payload, route) {
    return api.postClientEvent(JSON.stringify(_objectSpread(_objectSpread({}, payload), {}, {
      hostname: location.hostname,
      rev: process.env.versionInfo,
      ua: navigator ? navigator.userAgent : navigator,
      route: {
        fullPath: route.fullPath,
        name: route.name
      }
    }))).catch(function (error) {
      // ユーザーに知らせる必要がないので無視する
    });
  };

  /**
   * テレメトリ情報を送信する
   * @param payload cf. `frontend/types/Telemetry.ts`
   */
  var $telemetry = {
    sendExportTelemetry: function sendExportTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return sendTelemetry(_objectSpread({
                type: 'export'
              }, payload), route);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    sendAssertionErrorTelemetry: function sendAssertionErrorTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return sendTelemetry(_objectSpread({
                type: 'assertionError'
              }, payload), route);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    sendErrorTelemetry: function sendErrorTelemetry(error, route) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return sendTelemetry({
                type: 'error',
                errorObjectJSON: stringifyErrorObject(error)
              }, route);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    sendEnvironmentTelemetry: function sendEnvironmentTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return sendTelemetry(_objectSpread({
                type: 'env'
              }, payload), route);
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    sendDocumentViewTelemetry: function sendDocumentViewTelemetry(route) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return sendTelemetry({
                type: 'pageview'
              }, route);
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    sendPDFPageViewTelemetry: function sendPDFPageViewTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return sendTelemetry(_objectSpread({
                type: 'pdf-page-view'
              }, payload), route);
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    sendWebSectionViewTelemetry: function sendWebSectionViewTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return sendTelemetry(_objectSpread({
                type: 'web-section-view'
              }, payload), route);
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    sendImpressionTelemetry: function sendImpressionTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return sendTelemetry(_objectSpread({
                type: 'impression'
              }, payload), route);
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    sendClickTelemetry: function sendClickTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return sendTelemetry(_objectSpread({
                type: 'click'
              }, payload), route);
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    sendHoverTelemetry: function sendHoverTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee0() {
        return regeneratorRuntime.wrap(function _callee0$(_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              _context0.next = 2;
              return sendTelemetry(_objectSpread({
                type: 'hover'
              }, payload), route);
            case 2:
            case "end":
              return _context0.stop();
          }
        }, _callee0);
      }))();
    },
    sendLookupTelemetry: function sendLookupTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee1() {
        return regeneratorRuntime.wrap(function _callee1$(_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              _context1.next = 2;
              return sendTelemetry(_objectSpread({
                type: 'lookup'
              }, payload), route);
            case 2:
            case "end":
              return _context1.stop();
          }
        }, _callee1);
      }))();
    },
    sendPurchaseLinkTelemetry: function sendPurchaseLinkTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return sendTelemetry(_objectSpread({
                type: 'purchase-link'
              }, payload), route);
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    sendToggleViewerTelemetry: function sendToggleViewerTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return sendTelemetry(_objectSpread({
                type: 'toggle-viewer'
              }, payload), route);
            case 2:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    sendWandhAskTelemetry: function sendWandhAskTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return sendTelemetry(_objectSpread({
                type: 'wandh-ask'
              }, payload), route);
            case 2:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    sendSearchTelemetry: function sendSearchTelemetry(payload, route) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return sendTelemetry(_objectSpread({
                type: 'search'
              }, payload), route);
            case 2:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    }
  };

  /**
   * assertionが失敗したらテレメトリ送信
   */
  var $assert = function $assert(condition, message, route) {
    if (!condition) {
      $telemetry.sendAssertionErrorTelemetry({
        message: message
      }, route).catch(function () {
        return true;
      });
    }
    return condition;
  };
  inject('telemetry', $telemetry);
  inject('assert', $assert);
});
export var useTelemetry = function useTelemetry() {
  var _useNuxtApp = useNuxtApp(),
    $telemetry = _useNuxtApp.$telemetry;
  return $telemetry;
};